import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { Stars } from "../MemberExtras";

export const ReviewsAdmin = () => {
  const [status, setStatus] = useState("pending");
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get(`/admin/reviews?status=${status}`).then((r) => setItems(r.data)), [status]);
  useEffect(() => { load(); }, [load]);
  const act = async (id, a) => {
    try { await api.post(`/admin/reviews/${id}/${a}`); toast.success(a === "approve" ? "Review published" : "Review rejected"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div data-testid="reviews-admin">
      <div className="flex gap-2">
        {["pending", "approved", "rejected"].map((s) => (
          <button key={s} data-testid={`reviews-filter-${s}`} onClick={() => setStatus(s)} className={`rounded-full px-4 py-1.5 text-sm border ${status === s ? "border-[#38BDF8] text-[#38BDF8]" : "border-white/10 text-slate-400"}`}>{s}</button>
        ))}
      </div>
      <div className="mt-6 grid md:grid-cols-2 gap-4">
        {items.map((r) => (
          <div key={r.id} data-testid={`admin-review-${r.id}`} className="lux-card p-5">
            <Stars value={r.rating} tid={`admin-review-stars-${r.id}`} />
            <p className="text-sm mt-3">"{r.text}"</p>
            <p className="text-xs text-slate-500 mt-3">{r.alias} · {r.vacation_title}</p>
            {r.status === "pending" && (
              <div className="mt-4 flex gap-2">
                <button data-testid={`admin-review-approve-${r.id}`} onClick={() => act(r.id, "approve")} className="btn-gold px-4 py-2 text-xs">Approve</button>
                <button data-testid={`admin-review-reject-${r.id}`} onClick={() => act(r.id, "reject")} className="btn-ghost px-4 py-2 text-xs text-red-300">Reject</button>
              </div>
            )}
          </div>
        ))}
        {items.length === 0 && <p className="text-sm text-slate-500" data-testid="reviews-admin-empty">No {status} reviews.</p>}
      </div>
    </div>
  );
};
